// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.submit-btn {
  background-color: #565b60 !important;
  border-color: #565b60 !important;
  color: #fff !important;
  border-radius: 40px !important;
  border: 1px solid #565b60 !important;
}

.form-control {
  font-family: "Open Sans";
}
.breadcrumb-item + .breadcrumb-item::before {
  float: none !important;
  padding-right: .5rem;
  color: #6c757d;
  content: "/";
}`, "",{"version":3,"sources":["webpack://./src/Pages/Updatepassword/updatepassword.css"],"names":[],"mappings":"AAGA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;EACtB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,YAAY;AACd","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');\r\n\r\n\r\n.submit-btn {\r\n  background-color: #565b60 !important;\r\n  border-color: #565b60 !important;\r\n  color: #fff !important;\r\n  border-radius: 40px !important;\r\n  border: 1px solid #565b60 !important;\r\n}\r\n\r\n.form-control {\r\n  font-family: \"Open Sans\";\r\n}\r\n.breadcrumb-item + .breadcrumb-item::before {\r\n  float: none !important;\r\n  padding-right: .5rem;\r\n  color: #6c757d;\r\n  content: \"/\";\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
